import { render, staticRenderFns } from "./TurnPreferencesUploadFile.html?vue&type=template&id=3c6d77af&external"
import script from "./TurnPreferencesUploadFile.ts?vue&type=script&lang=ts&external"
export * from "./TurnPreferencesUploadFile.ts?vue&type=script&lang=ts&external"
import style0 from "./TurnPreferencesUploadFile.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports